var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import * as authSelectors from "../redux/auth/auth.selectors";
var withKycRequired = function (Component) {
    var WithKycRequired = function (props) {
        var user = useSelector(function (state) {
            return authSelectors.getUser(state);
        });
        // Helpers
        var userIsCompleted = function (_a) {
            var personalContact = _a.personalContact;
            var dateOfBirth = personalContact.dateOfBirth, nationality = personalContact.nationality, countryId = personalContact.countryId, street = personalContact.street, number = personalContact.number, city = personalContact.city, zip = personalContact.zip;
            return (dateOfBirth &&
                nationality &&
                countryId &&
                street &&
                number &&
                city &&
                zip);
        };
        // Render
        var renderRedirect = function (pathname) { return (_jsx(Navigate, { to: {
                pathname: pathname,
            }, state: {
                referrer: "".concat(window.location.pathname).concat(window.location.search),
                forPayment: true,
            } })); };
        if (user && !userIsCompleted(user)) {
            return renderRedirect("/kyc");
        }
        return _jsx(Component, __assign({}, props));
    };
    return WithKycRequired;
};
// eslint-disable-next-line import/no-default-export
export default withKycRequired;
